$(function () {
	//main Banner carousel
	$('.homeBannerCarousel__inner').flickity({
		adaptiveHeight: false,
		autoPlay: 5000,
		cellAlign: 'left',
		contain: true,
		draggable: true,
		pageDots: true,
		prevNextButtons: false,
		pauseAutoPlayOnHover: false,
		setGallerySize: true,
		wrapAround: true,
		on: {
			ready: function () {
				// Add pause button
				var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';
				$('.homeBannerCarousel__inner .flickity-page-dots').wrap('<div class="flickity-controls"/>');
				$(pause).insertAfter('.homeBannerCarousel__inner .flickity-page-dots');
			}
		}
	});

	//pagination workign with keyboard
	$('.homeBannerCarousel__inner .dot').attr('tabindex', '0');
	$('.homeBannerCarousel__inner .dot').on('keydown', function (e) {
		if (e.keyCode === 13) {
			var index = $(this).index();
			$('.homeBannerCarousel__inner').flickity('selectCell', index);
		}
	});
	$('.homeBannerCarousel__inner .flickity-button.pause').on('click', function () {
		let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

		$(this).attr('aria-selected', isPaused ? 'false' : 'true');
		$('.homeBannerCarousel__inner').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
	});

	if (!window.matchMedia('(min-width: 1200px').matches) {
		$('.homeBannerCarousel__inner').flickity('stopPlayer');
	}
});

function socialCarouselsInit() {
	//Twitter Social Carousel
	$('.twitter .socialBox_body').flickity({
		adaptiveHeight: false,
		autoPlay: 5000,
		cellAlign: 'left',
		contain: true,
		draggable: false,
		pageDots: false,
		prevNextButtons: true,
		pauseAutoPlayOnHover: false,
		wrapAround: false,
		on: {
			ready: function () {
				// Add pause button
				var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';
				$('.twitter  .socialBox_body .flickity-button.previous').wrap('<div class="flickity-controls"/>');
				$('.twitter  .socialBox_body .flickity-button.next').detach().appendTo('.twitter .socialBox_body .flickity-controls');
				$(pause).insertAfter('.twitter .socialBox_body .flickity-controls .flickity-button.previous');
				$('.twitter .socialBox_body .flickity-controls').detach().prependTo('.twitter .socialBox_footer');
			}
		}
	});
	$('.twitter .socialBox_footer .flickity-button.pause').on('click', function () {
		let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

		$(this).attr('aria-selected', isPaused ? 'false' : 'true');
		$('.twitter .socialBox_body').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
	});
	//facebook Social Carousel
	$('.facebook .socialBox_body').flickity({
		adaptiveHeight: false,
		autoPlay: 5000,
		cellAlign: 'left',
		contain: true,
		draggable: false,
		pageDots: false,
		prevNextButtons: true,
		pauseAutoPlayOnHover: false,
		wrapAround: false,
		on: {
			ready: function () {
				// Add pause button
				$('.socialBox_body').matchHeight();
				var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';
				$('.facebook .socialBox_body .flickity-button.previous').wrap('<div class="flickity-controls"/>');
				$('.facebook .socialBox_body .flickity-button.next').detach().appendTo('.facebook .socialBox_body .flickity-controls');
				$(pause).insertAfter('.facebook .socialBox_body .flickity-controls .flickity-button.previous');
				$('.facebook .socialBox_body .flickity-controls').detach().prependTo('.facebook .socialBox_footer');
			}
		}
	});
	$('.facebook .socialBox_footer .flickity-button.pause').on('click', function () {
		let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

		$(this).attr('aria-selected', isPaused ? 'false' : 'true');
		$('.facebook .socialBox_body').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
	});
}
